import { computed } from "@preact/signals";
import { dashboardStats, formatMoney, cents } from "@orderman/shared";
import { adminEvents } from "../../state/adminData.js";

// Auswertung: dieselbe geteilte Projektion (`dashboardStats`) wie Cloud-Portal/Konsole, nur
// mobil dargestellt. Reine Anzeige aus dem geladenen Event-Feed.

const stats = computed(() => (adminEvents.value ? dashboardStats(adminEvents.value) : null));

const money = (n: number) => formatMoney(cents(n));

function Kpi({ label, value }: { label: string; value: string }) {
  return (
    <div class="kpi">
      <div class="kpi-val">{value}</div>
      <div class="kpi-lbl">{label}</div>
    </div>
  );
}

export function ReportView() {
  const s = stats.value;
  if (!s) return <div class="admin-empty">Lade Auswertung…</div>;
  const maxWaiter = s.byWaiter.length ? Math.max(...s.byWaiter.map((w) => w.revenueCents)) : 0;
  const maxHour = s.byHour.length ? Math.max(...s.byHour.map((h) => h.revenueCents)) : 0;

  return (
    <div class="admin-scroll">
      <div class="kpi-grid">
        <Kpi label="Umsatz" value={money(s.revenueCents)} />
        <Kpi label="Bestellungen" value={String(s.orderCount)} />
        <Kpi label="Belege" value={String(s.belegCount)} />
        <Kpi label="Ø Beleg" value={money(s.avgBonCents)} />
        <Kpi label="Trinkgeld" value={money(s.tipCents)} />
      </div>

      <section class="rep-sec">
        <h3>Umsatz je Kellner</h3>
        {s.byWaiter.length === 0 ? (
          <p class="admin-empty">Noch kein Umsatz.</p>
        ) : (
          s.byWaiter.map((w) => (
            <div key={w.name} class="bar-row">
              <span class="bar-name">{w.name}</span>
              <span class="bar">
                <span class="bar-fill" style={{ width: `${maxWaiter ? (w.revenueCents / maxWaiter) * 100 : 0}%` }} />
              </span>
              <span class="bar-val">{money(w.revenueCents)}</span>
            </div>
          ))
        )}
      </section>

      <section class="rep-sec">
        <h3>Top-Artikel</h3>
        {s.topItems.length === 0 ? (
          <p class="admin-empty">Noch keine Verkäufe.</p>
        ) : (
          <div class="rep-items">
            {s.topItems.map((it) => (
              <div key={it.name} class="rep-item">
                <span class="rep-item-qty">{it.qty}×</span>
                <span class="rep-item-name">{it.name}</span>
                <span class="rep-item-rev">{money(it.revenueCents)}</span>
              </div>
            ))}
          </div>
        )}
      </section>

      {s.byHour.length > 0 && (
        <section class="rep-sec">
          <h3>Umsatz je Stunde</h3>
          {s.byHour.map((h) => (
            <div key={h.hour} class="bar-row">
              <span class="bar-name">{String(h.hour).padStart(2, "0")}:00</span>
              <span class="bar">
                <span class="bar-fill" style={{ width: `${maxHour ? (h.revenueCents / maxHour) * 100 : 0}%` }} />
              </span>
              <span class="bar-val">{money(h.revenueCents)}</span>
            </div>
          ))}
        </section>
      )}
    </div>
  );
}
